import { useMutation, useQueryClient } from 'react-query';

import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface DeleteProceduralEventParams {
  matterId: string;
  eventId: string;
}

export const useDeleteProceduralEvent = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<void, Error, DeleteProceduralEventParams>(
    async ({ matterId, eventId }) => {
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/procedural-timeline/events/${eventId}`,
        getFetchConfig({ method: FetchMethod.DELETE }),
      );
      if (!res.ok) {
        const detail = await res.text().catch(() => '');
        throw new Error(detail || 'Failed to delete event');
      }
    },
    {
      onSuccess: (_, { matterId, eventId }) => {
        queryClient.invalidateQueries([QueryEntity.ProceduralTimelineEvents, { matterId }]);
        trackCustomEvent(TrackingEventsV2.ProceduralTimelineEventDelete, { matterId, eventId });
      },
    },
  );
};
